/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
// tslint:disable max-file-line-count
// Core
import { Component, OnInit, OnDestroy, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
// import {SETTINGS} from '@environment/settings';
// Services
import { AccountLandingService } from '@experience/landing/common/components/account-landing/services/account-landing.service';
import { UserService } from '@support/shared/services/user.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { LoggerService } from '@core/logger/services/logger.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { RestoreServiceSuccess } from '@experience/landing/common/interfaces/restore-service-success.interface';
import { RestoreService } from '@support/shared/services/restore.service';
// Components
import { LineDetailsComponent } from '@experience/landing/common/components/line-details/line-details.component';
import { StaticModalComponent } from '@support/shared/widgets/components/static-modal/static-modal.component';
import { RestoreServiceModalComponent } from '@experience/landing/common/components/restore-service-modal/restore-service-modal.component';
// Interfaces
import {
  CustomerSessionPassDetails,
  CustomerSessionPassDetailsLines,
  CustomerSessionPassDetailsLineDetailsPassDetails,
} from '@support/api/proxies/responses/api-2010.interface';
import {
  LinesDetail,
  CustomerAccountLineBillingDetails,
} from '@support/api/proxies/responses/api-2040.interface';
import {
  CustomerAccountBillingDetails,
  LineSummary,
} from '@support/api/proxies/responses/api-2006.interface';
import {
  ConfigData,
  AEMContentData,
  AuthorableData,
} from '@experience/repdash/interfaces/aem-content.interface';
import { SelectItem } from '@support/shared/interfaces/select-item.interface';
import { StaticModal } from '@support/shared/widgets/interfaces/static-modal.interface';
import { APIError } from '@support/api/common/error.interface';
import {
  CustomerUsageSummaryResults,
  CustomerUsageSummaryResultsLines,
} from '@support/api/proxies/responses/api-2009.interface';
import { KeyValueMap } from '@support/shared/interfaces/key-value-map.interface';
import {
  OrderSearchResponse,
  OrderSearchResults,
} from '@experience/repdash/interfaces/order-profile.interface';
// Pipes
import { PhonePipe } from '@support/shared/widgets/pipes/phone/phone.pipe';
// Constants
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import {
  LINE_LANDING_CONSTANTS,
  ORDER_TYPES,
} from '@experience/landing/common/components/line-landing/line-landing.constants';
import { LineLandingService } from '@experience/landing/common/services/line-landing.service';
import { Line } from '@support/api/proxies/responses/api-2022.interface';
// model
import { LinePendingOrdersModel } from '@experience/landing/common/models/line-pending-orders.model';
import { WindowRefService } from '@support/shared/services/window-ref.service';
import { AlertEventInterface } from '@support/shared/widgets/interfaces/toggle-alert.interface';

@Component({
  selector: 'tmo-line-landing',
  templateUrl: './line-landing.component.html',
  styleUrls: ['../../../../../../style-sheets/components/html-accordion.component.scss'],
})
export class LineLandingComponent implements OnInit, OnDestroy {
  /**
   * stores msisdn in phone format
   */
  public formattedMsisdn: string;
  /**
   * stores constant value of Permission Constant
   */
  public permissionConstants: KeyValueMap;
  /**
   * configurable data
   */
  public contentData: ConfigData;
  /**
   * boolean flag to keep track of orders response
   */
  public pendingOrdersModal: boolean;
  /**
   * Stores bill block details
   */
  public customerAccountBillingDetails: CustomerAccountBillingDetails;
  /**
   * To Toggle the Alerts
   */
  public toggleAlerts: boolean;
  /**
   * stores session pass data
   */
  public passDetails: CustomerSessionPassDetailsLineDetailsPassDetails;
  /**
   * StaicModal object
   */
  public modal: StaticModal;
  /**
   * Used to dispaly modify cancellation flow
   */
  public displayModifyCancellationBlade: Boolean;
  /**
   * Used to check pending order
   */
  public isPendingOrder: boolean;
  /**
   * Stores boolean value to identiy if notifcations have loaded
   */
  public notificationLoaded: boolean;
  /**
   * Stores Line details for the current line
   */
  public lineDetails: LineSummary;
  /**
   * Stores values of customer billing line details
   */
  public lineBillingDetails: LinesDetail;
  /**
   * Flag to check if single line or multiple line
   */
  public isSingleLine: boolean;
  /**
   * List of Lines to be shown as drop down
   */
  public options: SelectItem[];
  /**
   * Variable to hold Line Landing constants to be used in html
   */
  public lineLandingConstants: ConfigData;
  /**
   * Boolean flag to check if it is postpaid flow
   */
  public isPostpaid: boolean;

  /**
   * isWebChannel stores web channel value as string
   */
  // public isWebChannel?: boolean;
  /**
   * isActive stores line status
   */
  public isActive?: boolean;
  /**
   * lineStatus stores line status
   */
  public lineStatus?: string;
  /**
   * Variable to hold selected usage data
   */
  public selectedLineUsageSummary: CustomerUsageSummaryResultsLines;
  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;

  /**
   * Validates whether plan is pay go type or not.
   */
  public isPayGoType: boolean;
  /**
   * Validates whether IMEI is blocked or not.
   */
  public deviceDetailsLineInformation: Line;
  /**
   * stores error message object
   */
  public errorMessage: APIError[];
  /*
   * line pending orders model to filter ppending orders based on type
   */
  public linePendingOrdersModel: LinePendingOrdersModel;
  /**
   * Boolean to hold if plan is of typ tourist
   */
  public isTouristPlan: boolean;
  /**
   * Store the total number of notifications
   */
  public totalNotifications: number;
  /**
   * View Child reference for Restore Service Modal
   */
  @ViewChild('restoreServiceModal') public restoreServiceModal: RestoreServiceModalComponent;
  /**
   * View Child reference for Phone details
   */
  @ViewChild('phoneDetails') public phoneDetails: LineDetailsComponent;
  /**
   * This will work the holder for the child component
   * Used to open modal on load of line landing page in case cancelled msisdin is used
   */
  @ViewChild('staticModal') public staticModal: StaticModalComponent;
  /**
   * View Child reference for Line details
   */
  @ViewChild('target') public target: ElementRef;
  /**
   * Stores the order Id data.
   */
  public orderIdText: string;
  /**
   * Stores response for restoring services
   */
  public restoreServiceResponse: RestoreServiceSuccess;
  /**
   * boolean check to verify changes MSISDN data load completion
   */
  public isChangedMsisdnloaded: boolean;
  /**
   * Authorable data
   */
  public authorableData: AuthorableData;
  /**
   * boolean check line level fraud lock indicator from API2006
   */
  public fraudLockIndicator: boolean;
  /**
   * notification if fraud locked indicator true
   */

  public fraudLockedNotification: string;

  public broadbandFactsUrl: string;

  public pendingOrdersCountMessage: string;

  public pendingOrderCount: string;

  public customerAccountLIneBillingDetails: CustomerAccountLineBillingDetails;

  constructor(
    protected accountLandingService: AccountLandingService,
    protected userService: UserService,
    protected commonUtilService: CommonUtilService,
    protected phonePipe: PhonePipe,
    protected objectService: ObjectService,
    protected logger: LoggerService,
    protected router: Router,
    protected stateStoreUtilsService: StateStoreUtilsService,
    protected lineLandingService: LineLandingService,
    protected windowRefService: WindowRefService,
    public routeSnapshot: ActivatedRoute,
    public restoreService: RestoreService
  ) {
    this.notificationLoaded = false;
    this.toggleAlerts = true;
    this.pendingOrdersModal = false;
    this.displayModifyCancellationBlade = false;
    this.isPostpaid = false;
    // this.isWebChannel = false;
    this.isTouristPlan = false;
    this.modal = {
      headerText: '',
      bodyText: '',
      disableDismiss: false,
      modalName: 'line-landing-modal',
      disableEsc: true,
      buttons: [
        {
          id: LINE_LANDING_CONSTANTS.CONTINUE,
          type: LINE_LANDING_CONSTANTS.SUBMIT,
          name: '',
          class: LINE_LANDING_CONSTANTS.BUTTON_CLASS,
        },
      ],
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      closableText: '',
    };
    this.ngUnsubscribe = new Subject<void>();
    this.errorMessage = [];
    this.restoreServiceResponse = {
      orderId: '',
      isBlocked: false,
    };
    this.totalNotifications = 0;
    this.pendingOrderCount = LINE_LANDING_CONSTANTS.ZERO;
  }

  public ngOnInit(): void {
    this.permissionConstants = PERMISSION_CONSTANTS;
    // this.isWebChannel = SETTINGS.CHANNEL.toLowerCase() === 'web';
    this.loadData();
    this.lineLandingConstants = LINE_LANDING_CONSTANTS;
    this.isPostpaid = this.checkIfPostpaid();
    this.isChangedMsisdnloaded = true;
    this.lineLandingService.lineLandingErrors
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((errorObject: APIError) => {
        this.errorMessage.push(errorObject);
      });
    this.restoreService.restoreServiceErrors$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((errorObject: APIError) => {
        this.errorMessage.push(errorObject);
      });

    this.restoreService.restoreSuccessSubject$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((resp: RestoreServiceSuccess) => {
        this.restoreServiceResponse = resp;
        this.orderIdText = this.commonUtilService.messageFormatter(
          this.objectService.get(this.contentData, 'orderSuccess'),
          [this.restoreServiceResponse.orderId]
        );
      });

    this.lineLandingService.deviceDetailsLoaded$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((line: Line) => {
        if (this.commonUtilService.isNotEmpty(line)) {
          this.deviceDetailsLineInformation = line;
        }
      });
    this.setPreviousUrl(LINE_LANDING_CONSTANTS.LINE_LANDING);
    this.getCustomerAccountBillingDetails();
    this.target?.nativeElement.scrollIntoView();
  }

  /**
   * selection change is used to set selected line details
   * @param selectedLine LineSummary
   */
  public onMsisdnChange(selectedLine: LineSummary): void {
    this.displayModifyCancellationBlade = false;
    this.isChangedMsisdnloaded = false;
    this.errorMessage = [];
    this.lineDetails = selectedLine;
    this.checkLineStatus();
    this.getLineUsageDetails();
    this.getPendingOrderStatus();
    this.postMsisdnChangeRepDashEvent(selectedLine);
    this.checkFraudIndicator();
    this.getLineSessionPassDetails();
    // if (this.lineDetails.lineStatus.toUpperCase() === LINE_LANDING_CONSTANTS.CANCELLED && this.isWebChannel) {
    if (this.lineDetails.lineStatus.toUpperCase() === LINE_LANDING_CONSTANTS.CANCELLED) {
      this.staticModal.displayModal = true;
      this.staticModal.focusModal();
    }
    this.getLineBillingDetails();
  }

  /**
   * checks Fraud Indicator value from the response and display notification if true
   */
  public checkFraudIndicator(): void {
    this.fraudLockIndicator = this.objectService.get(
      this.lineDetails,
      'fraudLock.lineFraudLockIndicator'
    );
    const msisdn = this.phonePipe.transform(this.lineDetails.msisdn);
    this.fraudLockedNotification = this.commonUtilService.messageFormatter(
      this.contentData.fraudLocked,
      [msisdn]
    );
  }

  /**
   * called function to check line status
   * @return void
   */
  public checkLineStatus(): void {
    if (this.lineDetails.lineStatus.toUpperCase() === LINE_LANDING_CONSTANTS.ACTIVE) {
      this.isActive = true;
    }
    this.lineStatus = this.lineDetails.lineStatus.toUpperCase();
  }

  /**
   * called function to activate and deactivate modal
   * @param openModal
   * @return void
   */
  public openModal(openModal: boolean): void {
    this.modal.toggleModalEmitter.emit({ open: openModal });
  }

  /**
   * To redirect user to contactus page.
   * @param url - String url of the new route
   * @param isNewTab - boolean to open in new tab or not
   * @returns void
   */
  public routeToContactUs(url: string, isNewTab: boolean): void {
    this.commonUtilService.routeToGivenUrl(url, isNewTab);
  }

  /**
   * Unsubscribes for all subscriptions
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Sets the url of the page on click of report lost or theft button
   * @param url : stores the value of the url
   */
  public setPreviousUrl(url: string): void {
    this.stateStoreUtilsService.setPreviousUrl(url);
  }

  /**
   * Load the customer Account Details
   * Load customer notifications
   * @returns void
   */
  public loadData(): void {
    this.isSingleLine = true;
    this.isPayGoType = false;
    this.getConfigurableContent();
    this.loadBillBlockDetail();
    this.getLineBillingDetails();
    this.getLineSessionPassDetails();
  }

  /**
   * Function to get the total notifications
   * @param  $event: number
   * @returns void
   */
  public updateNotifications($event: number): void {
    this.totalNotifications = $event;
  }

  /**
   * Event emitter triggered on changes of alert toggle on page header
   * @returns void
   */
  public toggleAlertChange(event: AlertEventInterface): void {
    if (this.toggleAlerts !== event.toggleAlerts) {
      this.toggleAlerts = event.toggleAlerts;
    }
  }

  /**
   * Get Billing Details for selected line
   * @return void
   */
  public getLineBillingDetails(): void {
    this.userService
      .getCustomerBillingDetailsData()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (billingDetails: CustomerAccountLineBillingDetails) => {
          this.lineLandingService.selectedMsidin.next(billingDetails);
          if (this.commonUtilService.isNotEmpty(billingDetails.lineDetails)) {
            this.lineBillingDetails = billingDetails.lineDetails;
            this.customerAccountLIneBillingDetails = billingDetails;
            if (this.lineBillingDetails) {
              this.broadbandFactsUrl = this.objectService.get(
                this.lineBillingDetails,
                'plan.bbl',
                ''
              );
            }
          }
        },
        () => {
          this.lineLandingService.setErrorMessage(this.contentData.monthlyChargesError);
        }
      );
  }

  /**
   * Get session pass Details for selected line
   * @return void
   */
  public getLineSessionPassDetails(): void {
    this.userService
      .customerAccountLineSessionPassDetails()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (sessionPassDetails: CustomerSessionPassDetails) => {
          let lines: CustomerSessionPassDetailsLines[] = this.objectService.get(
            sessionPassDetails,
            'lines'
          );
          if (this.commonUtilService.isNotEmpty(lines)) {
            const lineId = this.stateStoreUtilsService.getLineId();
            lines = lines.filter(
              (line: CustomerSessionPassDetailsLines) => line.lineOfServiceId === lineId
            );
            const data = this.objectService.get(lines, '0.lineDetails.passDetails');
            this.passDetails = Object.assign({}, data);
          }
        },
        () => {
          this.lineLandingService.setErrorMessage(
            this.objectService.get(this.contentData, 'oneTimeChargesError')
          );
        }
      );
  }

  /**
   * Get configurable content
   * @return void
   */
  private getConfigurableContent(): void {
    this.accountLandingService
      .getLineDetailsContentData()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((contentData: AEMContentData) => {
        this.contentData = contentData.configurableData;
        this.authorableData = contentData.authorableData;
        this.modal = {
          headerText: this.contentData.contactSupport,
          bodyText: this.contentData.lineCancellationDescription,
          disableDismiss: false,
          disableEsc: true,
          buttons: [
            {
              id: LINE_LANDING_CONSTANTS.CONTINUE,
              type: LINE_LANDING_CONSTANTS.SUBMIT,
              name: this.contentData.contactUs,
              class: LINE_LANDING_CONSTANTS.BUTTON_CLASS,
            },
          ],
          toggleModalEmitter: new EventEmitter(),
          dismissableMask: true,
          closableText: this.contentData.clickToClose,
        };
        if (this.lineDetails) {
          this.checkFraudIndicator();
          // if (this.lineDetails.lineStatus &&
          //   this.lineDetails.lineStatus.toUpperCase() === LINE_LANDING_CONSTANTS.CANCELLED && this.isWebChannel) {
          if (
            this.lineDetails.lineStatus &&
            this.lineDetails.lineStatus.toUpperCase() === LINE_LANDING_CONSTANTS.CANCELLED
          ) {
            this.staticModal.displayModal = true;
            this.staticModal.focusModal();
          }
        }
      });
  }

  /**
   * Get Usage Details for selected line
   * @return void
   */
  private getLineUsageDetails(): void {
    this.isChangedMsisdnloaded = false;
    this.selectedLineUsageSummary = null;
    this.userService
      .getUsageDetails()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (usageSummary: CustomerUsageSummaryResults) => {
          this.isChangedMsisdnloaded = true;
          let lines: CustomerUsageSummaryResultsLines[] = this.objectService.get(
            usageSummary,
            'lines'
          );
          if (this.commonUtilService.isNotEmpty(lines)) {
            lines = lines.filter(
              (line: CustomerUsageSummaryResultsLines) => line.msisdn === this.lineDetails.msisdn
            );
            if (this.commonUtilService.isNotEmpty(lines)) {
              this.selectedLineUsageSummary = this.objectService.get(lines, '0');
            } else {
              this.selectedLineUsageSummary = {};
            }
          }
        },
        () => {
          this.selectedLineUsageSummary = {};
          this.errorMessage.push({ userMessage: this.contentData.usageDetailsError });
          this.isChangedMsisdnloaded = true;
        }
      );
  }

  /**
   * Loads the bill block details
   * @returns void
   */
  private loadBillBlockDetail(): void {
    this.userService
      .getCustomerAccountBillingSummary()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: CustomerAccountBillingDetails) => {
        this.customerAccountBillingDetails = response;
        if (this.commonUtilService.isNotEmpty(response)) {
          this.isPayGoType = response.payGoIndicator ? response.payGoIndicator : false;
          const lines = this.objectService.get(response, 'lines');
          if (this.commonUtilService.isNotEmpty(lines)) {
            const lineId = this.stateStoreUtilsService.getLineId();
            const msisdn = this.stateStoreUtilsService.getMsisdn();
            if (msisdn) {
              lines.filter((line: LineSummary) => {
                if (lineId === line.lineOfServiceId) {
                  this.lineDetails = line;
                }
              });
            }
          }
          if (this.lineDetails) {
            this.getPendingOrderStatus();
            this.checkLineStatus();
            this.stateStoreUtilsService.setMsisdn(this.lineDetails.msisdn);
            this.stateStoreUtilsService.setLineId(this.lineDetails.lineOfServiceId);
            this.stateStoreUtilsService.setSimNumber(
              this.objectService.get(this.lineDetails.networkResource, 'simNumber')
            );
            this.getLineUsageDetails();
            this.isSingleLine = lines.length <= 1;
          }
        }
      });
  }

  /**
   * Function to retrieve if customer plan is of type tourist
   * @returns void
   */
  private getCustomerAccountBillingDetails(): void {
    this.userService
      .getCustomerAccountBillingSummary()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: CustomerAccountBillingDetails) => {
        this.isTouristPlan = this.objectService.get(response, 'touristPlanIndicator');
      });
  }

  /**
   * Method to check if it is Postpaid flow
   * @returns boolean
   */
  private checkIfPostpaid(): boolean {
    const billingBlock = this.stateStoreUtilsService.getBillingBlockDetails();
    return this.objectService.get(billingBlock, 'billingType') === LINE_LANDING_CONSTANTS.POSTPAID
      ? true
      : false;
  }

  /**
   * Method to get pending orders from API 2813
   * @returns void
   */
  public getPendingOrderStatus(): void {
    this.pendingOrdersModal = false;
    this.isChangedMsisdnloaded = false;
    const msisdn: string = this.objectService.get(this.lineDetails, 'msisdn');
    const lookUpParams = { msisdn: msisdn };
    this.accountLandingService
      .getPendingOrderDetails(lookUpParams)
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe(
        (orderSearchResult: OrderSearchResponse) => {
          this.pendingOrdersModal = true;
          this.isChangedMsisdnloaded = true;
          const orderResults = this.objectService.get(orderSearchResult, 'orderSearchResults');
          this.stateStoreUtilsService.setPendingOrders(
            orderSearchResult.orderSearchResults,
            this.lineDetails.lineOfServiceId
          );
          if (orderResults && orderResults.length) {
            this.lineLandingService.pendingOrderSubject.next(orderResults);
            const allOrderSearchResultsFilterList: OrderSearchResults[] = orderResults.filter(
              (result: OrderSearchResults) => {
                return (
                  (result.orderStatus === LINE_LANDING_CONSTANTS.INPROCESS ||
                    result.orderStatus === LINE_LANDING_CONSTANTS.RECEIVED) &&
                  result.msisdn === msisdn
                );
              }
            );
            this.linePendingOrdersModel = new LinePendingOrdersModel(
              allOrderSearchResultsFilterList,
              this.objectService.get(this.contentData, 'orderTypes')
            );
            this.pendingOrderCount = this.linePendingOrdersModel.ordersByType?.[0]?.value?.length || 0;
          }
          this.pendingOrdersCountMessage = this.commonUtilService.messageFormatter(
            this.contentData.pendingOrderText,
            [this.pendingOrderCount]
          );
        },
        () => {
          this.pendingOrdersModal = true;
          this.lineLandingService.setErrorMessage(
            this.objectService.get(this.contentData, 'pendingOrdersError')
          );
          this.isChangedMsisdnloaded = true;
        }
      );
  }

  /**
   * To check whether one time charges blade is to be displayed or not.
   * @returns boolean
   */
  public showHideOneTimeChargeBlade(): boolean {
    if (this.passDetails && this.passDetails.active) {
      return this.passDetails.active.length > 0;
    } else if (this.selectedLineUsageSummary && this.selectedLineUsageSummary.overages) {
      return Object.keys(this.selectedLineUsageSummary.overages).length > 0;
    }
    return false;
  }

  /**
   * Posts custom event to repdash
   * @param selectedLine
   */
  private postMsisdnChangeRepDashEvent(selectedLine: LineSummary): void {
    if (
      this.windowRefService.nativeWindow() &&
      this.windowRefService.nativeWindow().RepdashEvent &&
      selectedLine
    ) {
      this.windowRefService.nativeWindow().RepdashEvent.dispatchEvent(
        new CustomEvent(LINE_LANDING_CONSTANTS.REPDASH_UPDATE_EVENT, {
          detail: {
            msisdn: selectedLine.msisdn,
            msisdnStatus: selectedLine.lineStatus,
          },
        })
      );
    }
  }
}
